import * as React from "react";
import { MessageFeedback, type FeedbackRating } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function MessageFeedbackDemo() {
  // Controlled rating; onRate resolves so the "thanks" confirmation shows.
  const [rating, setRating] = React.useState<FeedbackRating>(0);

  // A rejecting submit so the optimistic selection visibly rolls back.
  const failingRate = (): Promise<void> => Promise.reject(new Error("submit failed"));

  return (
    <Section
      id="message-feedback"
      title="MessageFeedback"
      description="Thumbs-up / thumbs-down rating for an assistant message, with optimistic selection + rollback on a failed submit. Controlled via value; it renders the selection optimistically on click and calls onRate with the new rating (0 toggles the current choice off). After a successful non-zero rating it shows a brief auto-hiding thanks. Safe under prefers-reduced-motion (transition-colors only)."
    >
      <VariantBlock label="Controlled" caption="click a thumb — the selection is optimistic and a brief thanks confirmation shows">
        <div className="flex flex-col gap-2 rounded-lg border border-border bg-card p-4">
          <p className="max-w-sm text-sm text-foreground">
            Sure — derivatives measure the instantaneous rate of change of a function.
          </p>
          <MessageFeedback
            value={rating}
            onRate={(r) => {
              setRating(r);
              return Promise.resolve();
            }}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Rollback on failure" caption="onRate rejects, so the optimistic selection reverts (no thanks shown)">
        <div className="rounded-lg border border-border bg-card p-4">
          <MessageFeedback onRate={failingRate} />
        </div>
      </VariantBlock>
    </Section>
  );
}
